import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const finalCTA = {
  headline: "Your Transformation Starts Today",
  message: "Join thousands of women who've discovered the power of feeling supported, confident, and empowered in their own skin.",
  cta: "Join the Waisted Momma Movement"
};

const FinalCTASection = () => {
  return (
    <section className="section-spacing bg-gradient-to-br from-primary/20 via-accent/15 to-secondary/20 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-accent/10 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        {/* Icon */}
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg mb-8">
          <Sparkles className="w-8 h-8 accent-gold" />
        </div>

        {/* Headline */}
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-semibold text-foreground mb-6 leading-tight">
          {finalCTA.headline}
        </h2>

        {/* Message */}
        <p className="text-lg sm:text-xl text-muted-foreground font-sans mb-10 leading-relaxed max-w-2xl mx-auto">
          {finalCTA.message}
        </p>

        {/* CTA Button */}
        <Button 
          size="lg" 
          className="bg-accent-gold hover:bg-accent-gold/90 text-white font-sans font-bold text-base tracking-wider px-10 py-7 rounded-lg shadow-xl hover-lift group"
        >
          {finalCTA.cta}
          <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </Button>

        {/* Trust badges */}
        <div className="mt-12 flex flex-wrap justify-center items-center gap-6 text-sm font-sans text-muted-foreground">
          <div className="flex items-center gap-2">
            <span className="text-accent-gold text-xl">✓</span>
            <span>Free Shipping</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-accent-gold text-xl">✓</span>
            <span>30-Day Returns</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-accent-gold text-xl">✓</span>
            <span>Secure Checkout</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
